import PropTypes from "prop-types";
import { createRef, Component } from "react";

export class MarionetteToReact extends Component {
    static defaultProps = {
        className: "",
        childClassName: "",
        style: {},
        eventHandler: () => {}
    }
    
    static propTypes = {
        View: PropTypes.func.isRequired, // Can't use PropTypes.instanceOf(View) here because of error
        className: PropTypes.string,
        childClassName: PropTypes.string,
        style: PropTypes.objectOf(PropTypes.string),
        eventHandler: PropTypes.func
    }
    
    constructor(props) {
        super(props);
        this.element = createRef();
    }
    
    componentDidMount() {
        this.renderMarionetteComponent();
    }
    
    // Re-render the component after every React update
    componentDidUpdate() {
        this.renderMarionetteComponent();
    }
    
    componentWillUnmount() {
        this.marionetteView.destroy();
    }
    
    renderMarionetteComponent() {
        if (this.marionetteView) {
            this.marionetteView.destroy();
            this.marionetteView = null;
        }
        
        const { View: MnView, ...props } = this.props;
        delete props.className;
        if (props.childClassName) {
            props.className = props.childClassName;
        }
        this.marionetteView = new MnView(props);
        this.marionetteView.on("all", (...args) => {
            if (typeof this.props.eventHandler === "function") {
                this.props.eventHandler(...args);
            }
        });
        this.marionetteView.render();
        
        if (this.element.current) {
            this.element.current.appendChild(this.marionetteView.el);
        }
    }
    
    render() {
        return (
            <div
                style={this.props.style}
                className={this.props.className}
                data-origin="marionette-to-react"
                ref={this.element}
            />
        );
    }
}
